import React from 'react'
import { AlertProps } from '.'
import { AlertContainer, AlertMessage } from './Alert.styled'
import warning from 'assets/icons/warning.svg'
import SVG from 'react-inlinesvg'

const Alert: React.FC<AlertProps> = ({ msg, type }) => {
  return (
    <AlertContainer type={type}>
      {type === 'danger' && <SVG src={warning} style={{ marginLeft: 16 }} />}
      <AlertMessage type={type}>{msg}</AlertMessage>
    </AlertContainer>
  )
}
export default Alert
